import * as React from 'react';
import useUser from '../../hooks/useUser';
import CollapsibleSidebar from '../collapsible-sidebar/collapsible-sidebar';
import AdminMenu from './adminMenu';
import * as styles from './layout.module.scss';

/**
 * AdminToolbar
 * @function AdminToolbar - Displays the left toolbar on the main page
 */
const AdminToolbar = () => {
  const [collapsed, setCollapsed] = React.useState(localStorage.getItem('adminSidebarCollapsed') === 'true');
  const { fetchCurrentUserRole, currentUserRole, loadingAssociatedData } = useUser();
  const [userRole, setUserRole] = React.useState<string>('');

  React.useEffect(() => {
    fetchCurrentUserRole();
  }, []);

  React.useEffect(() => {
    localStorage.setItem('adminSidebarCollapsed', String(collapsed));
  }, [collapsed]);

  React.useEffect(() => {
    if (!loadingAssociatedData) {
      setUserRole(currentUserRole);
    }
  }, [loadingAssociatedData]);

  return (
    <React.Fragment>
      <CollapsibleSidebar
        initialCollapse={collapsed}
        collapsedClass={styles.collapsed}
        sidebarClass={styles.sidebar}
        onCollapseToggle={(collapseState: boolean) => setCollapsed(collapseState)}
      >
        {!loadingAssociatedData && <AdminMenu collapsed={collapsed} userRole={userRole} />}
      </CollapsibleSidebar>
    </React.Fragment>
  );
};

export default AdminToolbar;
